import { Vue, Component, Prop } from 'vue-property-decorator'
import { Location } from 'vue-router'
import LinkPaginate from '~/components/element/LinkPaginate'
import s from '~/utils/s'

@Component
export default class Pagination extends Vue {
  @Prop({ type: Function, required: true, default: new Function() })
  readonly loadMoreMethod?: Function

  @Prop({ type: Number, required: true, default: 0 })
  readonly total?: number

  @Prop({ type: Number, required: true, default: 0 })
  readonly perPage?: number

  @Prop({ type: Number, default: 1 })
  readonly currentPage?: number

  get pageCount (): number {
    if (this.total && this.perPage) {
      return Math.ceil(this.total / this.perPage)
    }

    return 0
  }

  get page (): number {
    return this.currentPage || 0
  }

  get isShow (): boolean {
    return this.pageCount > 1
  }

  get loadMoreLink (): Location {
    const targetPage = this.page + 2
    const query = this.$route.query

    return {
      path: this.$route.path,
      query: {
        ...query,
        page: targetPage.toString()
      }
    }
  }

  renderPaginate () {
    if (this.isShow) {
      return (
        <div class="entity-list-block__content-paginate">
          <LinkPaginate {...{
            props: {
              pageCount: this.pageCount,
              selected: this.page
            }
          }} />
        </div>
      )
    }
  }

  renderLoadButton () {
    const showBtn = this.total && this.page < this.pageCount - 1

    if (showBtn) {
      return (
        <div class="entity-list-block__content-fetch">
          <nuxt-link {...{
            class: 'entity-list-block__content-fetch-button',
            props: {
              to: this.loadMoreLink
            },
            nativeOn: {
              click: (event: MouseEvent) => {
                event.stopPropagation()

                if (this.loadMoreMethod) {
                  this.loadMoreMethod()
                }
              }
            }
          }}>
            Загрузить еще
          </nuxt-link>
        </div>
      )
    }
  }

  render () {
    return (
      <div class="pagination">
        { this.renderLoadButton() }
        { this.renderPaginate() }
      </div>
    )
  }
}
